import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useDisciplineProgressReportsStore, getCanonicalDisciplineProgressReportsQuery, queryToDisciplineProgressReportsFilters } from '@pages/discipline'
import { MAX_PER_PAGE, toPaginationValue } from '@shared/lib/routes'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

/**
 * `/disciplines/{id}/progress-reports` — query → store filters, as `middleware/discipline-tasks.ts` does. A due
 * date the API would refuse is dropped from the URL once, so the URL, the picker and the request always agree.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const filters = queryToDisciplineProgressReportsFilters(to.query)
  const canonicalQuery = getCanonicalDisciplineProgressReportsQuery(to.query, filters)

  if (canonicalQuery) {
    return navigateTo({ path: to.path, query: canonicalQuery }, { replace: true })
  }

  const store = useDisciplineProgressReportsStore()

  store.setFilters(filters)
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
  store.setEditingReport(null)
})
